<template>
  <div style="height: 561px; border-bottom: 2px solid #297286; border-right: 2px solid #297286;">
    <v-sheet height="561">
      <div v-if="clientEvents.length === 0" class="d-flex align-center justify-center" style="height: 100%;">
        <v-icon color="grey" size="36">mdi-information-outline</v-icon>
        <span class="ml-2 grey--text text--darken-1">No client events to display</span>
      </div>

      <v-timeline v-else class="overflow-y-auto" side="end" dense>
        <v-timeline-item
          v-for="(event, index) in clientEvents"
          :key="event.eventId || index"
          dot-color="#d3d3d3"
          :size="35"
        >
          <template v-slot:icon>
            <img v-if="event.severity && event.severity.includes('FATAL')"
              :src="require('../assets/fatal5.png')" alt="Fatal" title="Fatal" style="width: 35px;" />
            <img v-else-if="event.eventType && event.eventType.includes('DEVICE')"
              :src="require('../assets/device.png')" alt="Device" title="Device Event" style="width: 35px;" />
            <img v-else-if="event.eventType && event.eventType.includes('LOCATION_SERVICE')"
              :src="require('../assets/locate.png')" alt="Location" title="Location Service" style="width: 35px;" />
            <img v-else-if="event.eventType && event.eventType.includes('NETWORKING')"
              :src="require('../assets/wifi.png')" alt="Networking" title="Networking Issue" style="width: 35px;" />
            <img v-else-if="event.eventType && event.eventType.includes('POWER')"
              :src="require('../assets/battery.png')" alt="Power" title="Power Issue" style="width: 35px;" />
          </template>

          <div style="text-align: left">
            <strong>{{ formatTime(event.timestamp) }}</strong>
          </div>
          <div class="mb-2" style="text-align: left">
            {{ event.message }}
          </div>
        </v-timeline-item>
      </v-timeline>
    </v-sheet>
  </div>
</template>


<script>
import { dateService } from "@/services/date.service.js";

export default {
    name: 'ClientEventsView',
    computed: {
        clientEvents() {
            const events = this.$store.state.tracks?.clientEvents || [];
            console.log("Computed clientEvents:", events);
            return events;
        }
    },
    watch: {
        clientEvents: {
            Handler(newVal, oldVal) {
                console.log("clientEvents changed:", newVal);
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        formatTime(timestamp) {
            return dateService.getDateTime(timestamp);
        },
        getColor(severity) {
            const sev = Array.isArray(severity) ? severity[0] : severity;
            switch (sev) {
                case 'FATAL':
                    return 'red darken-2';
                case 'WARN':
                    return 'orange darken-2';
                case 'INFO':
                    return 'blue lighten-2';
                default:
                    return 'grey';
            }
        },
        getIcon(eventType) {
            switch (eventType) {
                case 'DEVICE':
                    return 'mdi-laptop';
                case 'LOCATION_SERVICE':
                    return 'mdi-crosshairs-gps';
                case 'NETWORKING':
                    return 'mdi-wifi-off';
                default:
                    return 'mdi-alert-circle-outline';
            }
        }
    }
};
</script>

<style scoped>
.v-timeline {
    padding: 0px;
}
</style>
